module.exports = __webpack_public_path__ + "img/say-bg.3ed5e38e.png";